export default __webpack_public_path__ + "static/media/video_instagram_portrait.f548d5d2.mp4";